import { createAction } from '@saucelabs/sl-util-redux';

import types from './types';

const addMobileLogLines = createAction(types.MOBILE_LOG_LINE_ADD);
const loadMoreMobileLogLines = createAction(types.MOBILE_LOG_LINES_LOAD_MORE);
const pauseMobileLogLines = createAction(types.MOBILE_LOG_LINES_PAUSE);
const resumeMobileLogLines = createAction(types.MOBILE_LOG_LINES_RESUME);
const setMobileLogLevel = createAction(types.MOBILE_LOG_SET_LOG_LEVEL);
const clearMobileLog = createAction(types.MOBILE_LOG_CLEAR);
const updateDisplayedMobileLogLines = createAction(types.MOBILE_LOG_UPDATE_DISPLAYED_LINES);
const updateMobileLogFilters = createAction(types.MOBILE_LOG_UPDATE_FILTERS);
const downloadMobileLog = createAction(types.MOBILE_LOG_DOWNLOAD_LOG);
const expandMobileLogSearch = createAction(types.MOBILE_LOG_EXPAND_SEARCH);
const textWrapMobileLog = createAction(types.MOBILE_LOG_WRAP_TEXT);
const changeMobileAppLog = createAction(types.MOBILE_LOG_CHANGE_APP);
const updateSessionApp = createAction(types.MOBILE_LOG_UPDATE_SESSION);

export default {
  addMobileLogLines,
  loadMoreMobileLogLines,
  pauseMobileLogLines,
  resumeMobileLogLines,
  setMobileLogLevel,
  clearMobileLog,
  updateDisplayedMobileLogLines,
  updateMobileLogFilters,
  downloadMobileLog,
  expandMobileLogSearch,
  textWrapMobileLog,
  changeMobileAppLog,
  updateSessionApp,
};
